import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '@/services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const token = authService.getToken();

    let authReq = req;

    const publicEndpoints = [
        '/auth/login',
        '/auth/forgot-password',
        '/auth/reset-password',
        '/auth/validate-token',
        '/usuarios/perfil/foto/' // Endpoint público para visualizar fotos de perfil
    ];

    const isPublicEndpoint = publicEndpoints.some((endpoint) => req.url.includes(endpoint));

    if (token && !isPublicEndpoint) {
        authReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if ((error.status === 401 || error.status === 403) && !isPublicEndpoint) {
                authService.logout();
                router.navigate(['/auth/login']);
            }

            return throwError(() => error);
        })
    );
};
